import { render, staticRenderFns } from "./BatchControls.vue?vue&type=template&id=36dd7938&scoped=true&"
import script from "./BatchControls.vue?vue&type=script&lang=js&"
export * from "./BatchControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dd7938",
  null
  
)

export default component.exports